var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.news),function(n){return _c('div',{key:n.id},[_c('div',{staticClass:"newsTitle"},[_c('h3',{domProps:{"innerHTML":_vm._s(n.title)}})]),_c('div',{staticClass:"newsType",domProps:{"innerHTML":_vm._s(n.label+' '+n.date)}}),_c('div',{staticClass:"newsText",domProps:{"innerHTML":_vm._s(n.text)}}),_c('hr')])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }